module.exports = __webpack_public_path__ + "static/media/dream-funnel-icon.56139846.svg";